<template>
    <div>
        <div
            class="relative z-10 w-screen pt-16 pb-4 min-h-[65lvh] bg-primary sm:pt-56 md:pt-40 md:min-h-0"
        >
            <div class="container">
                <div class="grid grid-cols-1 md:grid-cols-4">
                    <div class="hidden md:block"></div>
                    <div class="col-span-3">
                        <h3
                            class="max-w-2xl text-6xl font-display sm:text-7xl md:text-8xl text-primary"
                            v-html="sanitize($t('footer.leading'))"
                        ></h3>
                        <div class="relative my-8">
                            <div
                                class="absolute left-0 top-0 h-[1px] w-screen bg-primaryColor"
                            ></div>
                        </div>
                        <div
                            class="grid grid-cols-1 pt-12 mb-8 text-lg gap-y-8 text-primary sm:grid-cols-2 lg:grid-cols-3"
                        >
                            <div class="flex flex-col items-start gap-y-2">
                                <span class="font-bold">Say Hi!</span>
                                <a
                                    class="inline-block underline transition-colors underline-offset-4 hover:text-gray-300"
                                    href="mailto:mail@raphaelbernhart.at"
                                >
                                    mail@raphaelbernhart.at
                                </a>
                            </div>
                            <div class="flex flex-col gap-y-2">
                                <span class="font-bold">Social Media</span>
                                <WidgetSocialMedia />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <RightsBar />
    </div>
</template>

<script setup lang="ts">
import { sanitize } from '@/utility/Helpers';
</script>
